import { render, staticRenderFns } from "./findings.vue?vue&type=template&id=5a35526e&scoped=true"
import script from "./findings.vue?vue&type=script&lang=js"
export * from "./findings.vue?vue&type=script&lang=js"
import style0 from "./findings.vue?vue&type=style&index=0&id=5a35526e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a35526e",
  null
  
)

export default component.exports